import { openBlock as r, createElementBlock as s, normalizeClass as i } from "vue";
import { themeProp as o } from "../../composables/useTheme.js";
const t = /* @__PURE__ */ Object.assign({
  name: "DsDivider"
}, {
  __name: "divider",
  props: {
    ...o
  },
  setup(n) {
    return (e, a) => (r(), s("hr", {
      class: i(["ds-divider", `ds-divider--${e.theme}`])
    }, null, 2));
  }
}), c = t;
export {
  c as default
};
